module.exports = __webpack_public_path__ + "img/broken-garage-door-repair.80fed2be.webp";